import baseScmService from 'services/baseScmService';

const contestTemplateService = baseScmService.injectEndpoints({
  endpoints: (build) => ({
    createContestTemplate: build.mutation({
      query: (contestTemplate) => ({
        method: 'POST',
        url: '/contest-templates/',
        body: {
          academy_topic: {
            title: contestTemplate.academyTopicInput?.title,
            academy_module_id:
              contestTemplate.academyTopicInput?.academy_module?.id,
            bucket_id: contestTemplate.academyTopicInput?.lecture_bucket?.id,
            junction_number: contestTemplate.academyTopicInput?.junction_number,
          },
          course_group: contestTemplate.courseGroup,
          contest: contestTemplate.contest,
          live_lecture: contestTemplate.liveLecture,
          pre_lecture_content: contestTemplate.preLectureContent,
          post_lecture_content: contestTemplate.postLectureContent,
          literature_resource: contestTemplate.literatureResource,
        },
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useCreateContestTemplateMutation } = contestTemplateService;

export default contestTemplateService;
